import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  IPortalUserFilter,
  IPortalUserResponseModel,
  IPortalUserRoleEnum,
  IPortalUserSortColumnEnum,
} from 'Modules/Communication/PortalUsers/shared/models/PortalUsers'
import { DEFAULT_PAGE_TAKE } from 'shared/constants/filters'
import { ISortOrderEnum } from 'shared/models/List'

const portalUsersSlice = createSlice({
  name: 'portalUsers',
  initialState: {
    data: null as IPortalUserResponseModel | null,
    error: null,
    loading: false,
    filters: {
      clientId: '',
      searchText: '',
      portalUserRole: IPortalUserRoleEnum.all,
      sortColumn: IPortalUserSortColumnEnum.name,
      sortorder: ISortOrderEnum.asc,
      take: DEFAULT_PAGE_TAKE,
      skip: 0,
    } as IPortalUserFilter,
  },
  reducers: {
    // Handle payload (_) for redux-saga to pickup
    fetchRequest: (state, _: PayloadAction<IPortalUserFilter>) => {
      state.loading = true
    },
    fetchSuccess: (state, action: PayloadAction<IPortalUserResponseModel>) => {
      state.loading = false
      state.error = null
      state.data = action.payload
    },
    fetchError: (state, action) => {
      state.loading = false
      state.error = action.payload
    },
    updateFilters: (state, action: PayloadAction<IPortalUserFilter>) => {
      state.data = null
      state.loading = true
      state.filters = action.payload
    },
  },
})

export default portalUsersSlice
